export const formatNumber = (x = 0) => {
	return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : 0
}
export const formatNumberWithIntl = (number, digits = 2) => {
	return new Intl.NumberFormat('fr-FR', {
		minimumFractionDigits: digits,
		maximumFractionDigits: digits,
	})
		.format(number)
		.replace(',', '.')
}

export function formatNumberWithIntlV2(number) {
	const parts = number.toString().split('.')
	parts[0] = new Intl.NumberFormat('en-US', { useGrouping: true })
		.format(parts[0])
		.replace(/,/g, ' ')
	return parts.join('.')
}

export function cleanedPhneNumber(input) {
	const cleaned = input
		.split(',')
		.map(
			(num) => num.replace(/\D/g, ''), // remove all non-digit characters
		)
		.join(', ')
	return cleaned
}

export function formatNumberInput(value) {
	if (value === null || value === undefined) return ''

	let stringValue = String(value)

	// allow only digits, space, dot, comma, minus
	stringValue = stringValue.replace(/[^\d\s.,-]/g, '')

	// keep only first "-"
	if (stringValue.includes('-')) {
		stringValue =
			(stringValue.startsWith('-') ? '-' : '') + stringValue.replace(/-/g, '')
	}

	// normalize comma to dot (internally)
	const parts = stringValue.replace(',', '.').split('.')

	// keep only first decimal point
	const integerPart = parts[0]
	const decimalPart = parts.slice(1).join('')

	// format integer with spaces (ignore "-" while formatting)
	const isNegative = integerPart.startsWith('-')
	const int = integerPart.replace('-', '').replace(/\s/g, '')

	const formattedInt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

	const result =
		(isNegative ? '-' : '') +
		formattedInt +
		(parts.length > 1 ? `.${decimalPart.slice(0, 3)}` : '')

	return result
}
